var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightRedBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.834,
    height: 639,
    viewBox: "0 0 41.834 639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    "data-name": "Group 2234",
    transform: "translate(-1827.583 -440.417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 5,
    height: 639,
    transform: "translate(1846 440.417)",
    fill: "#c71e2d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 639,
    dur: "1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 5,
    height: 227,
    transform: "translate(1827.583 852.417)",
    fill: "#c71e2d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 639,
    dur: "1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 5,
    height: 448,
    transform: "translate(1864.417 631.417)",
    fill: "#c71e2d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 639,
    dur: "1.5s",
    fill: "freeze"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRedBars);
export default __webpack_public_path__ + "static/media/right_red_bars.ede2d2961033c8e692f9644f43738be3.svg";
export { ForwardRef as ReactComponent };